<style>

.input{
  display: grid;
  grid-template-columns: 55px 15px;
}
.month{
  grid-column: 1;
}
.arrow{
  grid-column: 2;
}

.grid{
  display: grid;
  grid-template-columns: 33% 33% 34%;
  margin-top: 20px;
}
.a{
  grid-column: 1;
  text-align: center;
  border: 1px rgba(0,0,0,0) solid;
  padding: 5px 0;
}
.b{
  grid-column: 2;
  text-align: center;
  border: 1px rgba(0,0,0,0) solid;
  padding: 5px 0;
}
.c{
  grid-column: 3;
  text-align: center;
  border: 1px rgba(0,0,0,0) solid;
  padding: 5px 0;
}

.sel{
  border: 1px rgba(0,0,0,1) solid;
  background-color: rgba(0,0,0,0.7);
  color: white;
}
</style>

<Dialog show="{showMonths}" title="Select A Month" buttons="{buttons}" on:close="{ () => showMonths = false}" on:done="{done}">
  
  <div class="grid">
    <div class="a {selM == 0 ? 'sel' : ''}" on:click="{ () => uSelM(0) }">Jan</div>
    <div class="b {selM == 1 ? 'sel' : ''}" on:click="{ () => uSelM(1) }">Feb</div>
    <div class="c {selM == 2 ? 'sel' : ''}" on:click="{ () => uSelM(2) }">Mar</div>
  </div>
  
  <div class="grid">
    <div class="a {selM == 3 ? 'sel' : ''}" on:click="{ () => uSelM(3) }">Apr</div>
    <div class="b {selM == 4 ? 'sel' : ''}" on:click="{ () => uSelM(4) }">May</div>
    <div class="c {selM == 5 ? 'sel' : ''}" on:click="{ () => uSelM(5) }">Jun</div>
  </div>
  
  <div class="grid">
    <div class="a {selM == 6 ? 'sel' : ''}" on:click="{ () => uSelM(6) }">Jul</div>
    <div class="b {selM == 7 ? 'sel' : ''}" on:click="{ () => uSelM(7) }">Aug</div>
    <div class="c {selM == 8 ? 'sel' : ''}" on:click="{ () => uSelM(8) }">Sep</div>
  </div>
  
  <div class="grid">
    <div class="a {selM == 9 ? 'sel' : ''}" on:click="{ () => uSelM(9) }">Oct</div>
    <div class="b {selM == 10 ? 'sel' : ''}" on:click="{ () => uSelM(10) }">Nov</div>
    <div class="c {selM == 11 ? 'sel' : ''}" on:click="{ () => uSelM(11) }">Dec</div>
  </div>
  
</Dialog>

<div class="input" on:click="{ () => showMonths = true }">
  <div class="month">{month == 'MM' || month == -1 ? 'MM' : months[month]}</div>
  <div class="arrow"><i class="icon-keyboard_arrow_down"></i></div>
</div>

<script>

import Dialog from "./Dialog.svelte";

export let month = "MM";

let months = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
let showMonths = false;
let buttons = [ {text: "Done", callback: "done", disabled: true, } ]

// selected month
let selM = -1;


function uSelM(i) {
  selM = i;
  buttons[0].disabled = false;
}

function done() {
  if (selM != -1) month = selM;
  console.log("month:", month);
  showMonths = false;
}



</script>